import request from '@/utils/request'

let StorageApi = {
 /*仓库列表*/
 storagelist(data, errorback) {
  return request._get('/shop/plus.storage.storage/index', data, errorback);
},
   /*获取仓库设置*/
   getDepot(data, errorback) {
    return request._get('/shop/setting.Depot/index', data, errorback);
  },
  /*修改仓库设置*/
  setDepot(data, errorback) {
    return request._post('/shop/setting.Depot/index', data, errorback);
  },
}
export default StorageApi;



// WEBPACK FOOTER //
// ./src/api/storage.js